// const ApiBase ='https://mser.markaship.com';
const ApiBase = "https://api-markaship.target-group.org/api";
export default ApiBase;
